import { render, staticRenderFns } from "./FeatureForm.vue?vue&type=template&id=231686f6"
import script from "./FeatureForm.vue?vue&type=script&lang=js"
export * from "./FeatureForm.vue?vue&type=script&lang=js"
import style0 from "./FeatureForm.vue?vue&type=style&index=0&id=231686f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports